import type { SpeedUnit, DistanceUnit } from "./units";

export interface TrackPoint {
    lat: number;
    lon: number;
    timestamp: number; // unix ms
    speed: number | null; // m/s from API
    heading: number | null; // degrees
}

export interface TripPhoto {
    dataUrl: string;
    timestamp: number; // unix ms, from EXIF DateTimeOriginal
}

export interface TripData {
    title: string;
    subtitle?: string;
    dateLabel?: string;
    boatName: string;
    boatPhoto?: string;
    fleetSlug: string;
    watermarkImage?: string;
    // Each outer element is one continuous underway segment (matches
    // VideoData.boatLocations on the Elm side) — gaps between segments are
    // time spent moored, excluded from underwayDurationSeconds.
    points: TrackPoint[][];
    startTime: number; // unix ms
    endTime: number; // unix ms
    totalDistanceM: number;
    avgSpeedMps: number;
    speedUnit: SpeedUnit;
    distanceUnit: DistanceUnit;
    underwayDurationSeconds: number;
    photos: TripPhoto[];
}

export interface VideoConfig {
    targetDurationSeconds: number; // 20 | 30 | 45 | 60 — total video length inc. intro/outro
    cameraMode: "follow" | "overview";
    terrainEnabled: boolean;
    trimStartSeconds: number;
    trimEndSeconds: number;
}

export interface ExportStatus {
    type: "idle" | "recording" | "encoding" | "complete" | "error";
    progress: number; // 0–1
    downloadUrl?: string;
    errorMessage?: string;
}

// Video dimensions (portrait for social)
export const VIDEO_WIDTH = 1080;
export const VIDEO_HEIGHT = 1920;
export const VIDEO_FPS = 30;

// Scene durations in frames
export const INTRO_FRAMES = 45; // 1.5s
export const OUTRO_FRAMES = 90; // 3s
